import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAvatar,{class:(_vm.customClass) ? _vm.customClass : '',attrs:{"color":(!_vm.avatar.img) ? _vm.GetColour(_vm.avatar.name) : null,"size":_vm.size}},[_vm._t("default"),(_vm.avatar.img)?_c('img',{attrs:{"src":_vm.avatar.img,"alt":_vm.avatar.name}}):_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.GetInitials(_vm.avatar.name))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }